/* SigueArmando · metas en el carrito: envío gratis ($29.990) y 5% de descuento ($39.900) */
(function () {
  if (window.__saMetas) return; window.__saMetas = true;
  var ENVIO = 29990, DESC = 39900;
  var money = function (n) { return '$' + Math.round(n).toLocaleString('es-CL'); };
  var last = null, timer = 0;

  function html(sub) {
    var msg, pct, ok = false;
    if (sub < ENVIO) { msg = 'Te faltan <strong>' + money(ENVIO - sub) + '</strong> para el <strong>envío gratis</strong>.'; pct = sub / ENVIO * 100; }
    else if (sub < DESC) { msg = '✓ Ya tienes envío gratis. Te faltan <strong>' + money(DESC - sub) + '</strong> para tu <strong>5% de descuento</strong>.'; pct = (sub - ENVIO) / (DESC - ENVIO) * 100; }
    else { msg = '🎉 ¡Tienes <strong>envío gratis</strong> y <strong>5% de descuento</strong> en tu compra!'; pct = 100; ok = true; }
    return '<div class="sa-metas' + (ok ? ' sa-metas--ok' : '') + '" role="status"><p>' + msg + '</p><div class="sa-metas__bar" aria-hidden="true"><i style="width:' + Math.max(3, Math.min(100, pct)).toFixed(0) + '%"></i></div></div>';
  }
  function paint(cart) {
    last = cart;
    var spots = document.querySelectorAll('.cart__ctas');
    Array.prototype.forEach.call(spots, function (ctas) {
      var prev = ctas.previousElementSibling;
      if (prev && prev.classList.contains('sa-metas')) prev.remove();
      if (!cart || !cart.item_count) return;
      ctas.insertAdjacentHTML('beforebegin', html(cart.items_subtotal_price / 100));
    });
  }
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(paint).catch(function () {});
    }, 150);
  }
  /* cuando el carrito se vuelve a dibujar (cajón o página), se repone el aviso */
  new MutationObserver(function () {
    if (last && !last.item_count) return;
    var need = Array.prototype.some.call(document.querySelectorAll('.cart__ctas'), function (c) {
      var p = c.previousElementSibling; return !(p && p.classList.contains('sa-metas'));
    });
    if (need) refresh();
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:cart:lines-update', refresh);
  document.addEventListener('cart:update', refresh);
  refresh();

  var css = document.createElement('style');
  css.textContent = '.sa-metas{margin:0 0 12px;padding:12px 14px;border-radius:12px;background:#FBF3E0;border:1px solid #F2D9A0;color:#1E3B2F;font-size:.92rem;line-height:1.4}.sa-metas p{margin:0 0 8px}.sa-metas--ok{background:#E3F0E7;border-color:#B9D9C3}.sa-metas__bar{height:6px;border-radius:9px;background:rgba(30,59,47,.12);overflow:hidden}.sa-metas__bar i{display:block;height:100%;background:linear-gradient(90deg,#F2B544,#E09A1E);border-radius:9px;transition:width .4s ease}.sa-metas--ok .sa-metas__bar i{background:#1F5A38}';
  document.head.appendChild(css);
})();
